import Box from '@sendsprint/ui-react/dist/components/Box';
import Text, { TextVariant } from '@sendsprint/ui-react/dist/components/Text';
import React, { ReactNode } from 'react';
import { ReactComponent as DownloadIcon } from './document-download.svg';

interface Props {
  children?: ReactNode;
  label: string;
  labelVariant?: TextVariant;
  className?: string;
  required?: boolean;
  downloadLabel?: string;
  downloadLink?: string;
}

const FormFieldWithExternalLabel = ({
  label,
  children,
  labelVariant = 'paragraphSmall',
  className,
  required,
  downloadLabel = 'Download',
  downloadLink
}: Props) => {
  return (
    <Box className={className}>
      <Box className="ss-flex ss-mb-1 ss-justify-between ss-items-center">
        <Text className="ss-text-neutral-500 ss-font-bold" variant={labelVariant}>
          {label} {required && <span className="ss-text-error-500 ss-ml-[2px]">*</span>}
        </Text>
        {downloadLink && (
          <a
            href={downloadLink}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="ss-inline-flex ss-items-center ss-underline">
            <Text variant="paragraphSmall" as="span">
              {downloadLabel}
            </Text>{' '}
            <DownloadIcon className="ss-w-4 ss-h-4" style={{ marginLeft: 4 }} />
          </a>
        )}
      </Box>

      <Box>{children}</Box>
    </Box>
  );
};

export default FormFieldWithExternalLabel;
